import { Component, Input, OnChanges } from '@angular/core';
import { SharedService } from '@app/core';
import {
  ApexChart,
  ApexFill,
  ApexGrid,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexResponsive
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  plotOptions: ApexPlotOptions;
  grid: ApexGrid
  fill: ApexFill;
};
@Component({
  selector: 'app-semi-donut-chart',
  templateUrl: './semi-donut.component.html',
  styleUrls: ['./semi-donut.component.scss']
})
export class SemiDonutChartComponent implements OnChanges {
  @Input() series: ApexNonAxisChartSeries;
  public chartOptions: Partial<ChartOptions>;

  constructor(private sharedService: SharedService) { }

  ngOnChanges() {
    this.chartOptions = {
      series: this.series,
      chart: {
        type: "radialBar",
        offsetY: 0
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            margin: 0,
            size: '80%',
            position: 'front',
          },
          track: {
            background: "#d1d1d1",
            margin: 0, // margin is in pixels
            strokeWidth: '100%',
          },
          dataLabels: {
            name: {
              show: false
            },
            value: {
              offsetY: 0,
              fontSize: "12px",
              fontWeight: 'bold',
              formatter: (val) => {
                return this.sharedService.formatNumber(val, false, 0, 2, true);
              }
            }
          }
        }
      },
      fill: {
        colors: ['#EBB901']
      },
      // labels: ["Average Results"]
    };
  }
}